import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { scanProducts, ScannedProduct } from '../utils/productScanner';
const NAMES = ['María', 'Carmen', 'Ana', 'Isabel', 'Laura', 'Sofía', 'Camila', 'Valeria', 'Mariana', 'Lucía', 'Elena', 'Daniela', 'Marta', 'Rosa', 'Paula', 'Juana', 'Teresa', 'Patricia', 'Alejandra', 'Andrea', 'Carlos', 'José', 'Juan', 'Luis', 'Miguel', 'Francisco', 'Antonio', 'Javier', 'Diego', 'Alejandro', 'Manuel', 'Jorge', 'Fernando', 'Roberto', 'Ricardo', 'Eduardo', 'Pedro', 'Raúl', 'Mario', 'Óscar'];
const CITIES = ['Miami', 'Houston', 'Los Angeles', 'Chicago', 'New York', 'Dallas', 'San Antonio', 'Phoenix', 'San Diego', 'San Jose', 'Austin', 'Jacksonville', 'Fort Worth', 'Columbus', 'Charlotte', 'San Francisco', 'Indianapolis', 'Seattle', 'Denver', 'Washington', 'Boston', 'El Paso', 'Nashville', 'Detroit', 'Oklahoma City', 'Las Vegas', 'Louisville', 'Baltimore', 'Milwaukee'];
interface ToastData {
  id: number;
  name: string;
  city: string;
  product: ScannedProduct;
}
export function RecentPurchaseToast() {
  const [currentToast, setCurrentToast] = useState<ToastData | null>(null);
  const [products, setProducts] = useState<ScannedProduct[]>([]);
  const usedNamesRef = useRef<string[]>([]);
  const toastIdCounter = useRef(0);
  const shouldReduceMotion = useReducedMotion();
  useEffect(() => {
    // Scan products on mount
    const scanned = scanProducts();
    setProducts(scanned);
  }, []);
  useEffect(() => {
    if (products.length === 0) return;
    let timeoutId: NodeJS.Timeout;
    const showNextToast = () => {
      // 1. Pick a product
      const product = products[Math.floor(Math.random() * products.length)];
      // 2. Pick a city
      const city = CITIES[Math.floor(Math.random() * CITIES.length)];
      // 3. Pick a name (avoiding last 10)
      let availableNames = NAMES.filter(n => !usedNamesRef.current.includes(n));
      if (availableNames.length === 0) {
        availableNames = NAMES; // Fallback if somehow all are used
      }
      const name = availableNames[Math.floor(Math.random() * availableNames.length)];
      // Update used names history
      usedNamesRef.current.push(name);
      if (usedNamesRef.current.length > 10) {
        usedNamesRef.current.shift();
      }
      // Create toast data
      const newToast: ToastData = {
        id: toastIdCounter.current++,
        name,
        city,
        product
      };
      setCurrentToast(newToast);
      // Hide after 4 seconds
      setTimeout(() => {
        setCurrentToast(null);
        // Schedule next toast (8-15 seconds after hiding)
        const nextInterval = Math.floor(Math.random() * (15000 - 8000 + 1)) + 8000;
        timeoutId = setTimeout(showNextToast, nextInterval);
      }, 4000);
    };
    // Initial toast after 3 seconds
    timeoutId = setTimeout(showNextToast, 3000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [products]);
  return <AnimatePresence data-id="element-237">
      {currentToast && <motion.div key={currentToast.id} initial={shouldReduceMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 50
    }} animate={shouldReduceMotion ? {
      opacity: 1
    } : {
      opacity: 1,
      y: 0
    }} exit={shouldReduceMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-[400px]" data-id="element-238">
          <div className="bg-white rounded-2xl shadow-xl border border-border p-3 flex items-center gap-4" data-id="element-239">
            <div className="flex-shrink-0 w-12 h-12 rounded-lg overflow-hidden border border-border bg-light" data-id="element-240">
              <img src={currentToast.product.thumbnailUrl} alt={currentToast.product.title} className="w-full h-full object-cover" data-id="element-241" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-242">
              <p className="text-sm text-body leading-tight" data-id="element-243">
                <span className="font-semibold text-dark" data-id="element-244">
                  {currentToast.name}
                </span>{' '}
                en {currentToast.city} acaba de comprar
              </p>
              <p className="text-sm font-medium mt-0.5 truncate" data-id="element-245">
                <span className="text-primary font-bold" data-id="element-246">
                  {currentToast.product.title}
                </span>{' '}
                —{' '}
                <span className="text-primary" data-id="element-247">
                  {currentToast.product.priceText}
                </span>
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}